import { createGlobalStyle } from "styled-components";

const Style = createGlobalStyle`
    body, button, input, textarea {
    font-family: 'Noto Sans KR', sans-serif;
  }
`;

export default Style;